<ng-container
  [templateStore]="{
    isMobile: (isMobile$ | async)
  }"
  #tStore="templateStore"
>
  <div
    id="display-text"
    (click)="openModal(tStore.isMobile)"
  >
    <ng-content select="[tooltipIcon]"></ng-content>
    <span class="tooltip-display-text" matTooltipClass="tooltip-text" [matTooltip]="!tStore.isMobile ? desktopTooltipText : null">
      <ng-content select="[displayText]"></ng-content>
    </span>
  </div>
</ng-container>


<sonder-modal
  class="full-screen-on-mobile"
  [sonderModalOpen]="showModal"
  (sonderModalClosed)="closeModal()"
>
  <ng-container class="header-actions-left">
    <ng-content select="[mobileHeaderIcon]"></ng-content>
    <ng-content select="[mobileHeaderText]"></ng-content>
  </ng-container>

  <ng-content select="[mobileBody]"></ng-content>

  <div class="sonder-modal-footer">
    <iris-button-container class="button-container">
      <iris-button
        [type]="irisButtonTypes.PRIMARY"
        data-test="close-tooltip-modal"
        (click)="closeModal()"
      >
        Close
      </iris-button>
    </iris-button-container>
  </div>
</sonder-modal>
